export default "__VITE_ASSET__C7c6inl$__"